import moment from 'utils/cops-moment';

export const defaultView = {
  id: 'workweek',
  description: '1 workweek',
  type: 'workhours',
  calendarType: 'week',
  parameters: {
    startHour: 8,
    endHour: 17,
    workingDays: [1, 2, 3, 4, 5],
    startOfWeek: 1,
    numberOfWeeks: 1,
    widthDayBreaker: 15,
  },
  startDay: moment().date(),
  startWeek: moment().week(),
  startMonth: moment().month(),
  startYear: parseInt(moment().format('YYYY'), 10),
};

export const indicatorOffset = '-7px';

export const widthBoundaries = {
  sm: 1100,
  lg: 1500,
};

export const indicatorInterval = 60000;

export const boardIdTypes = {
  service: 'service',
};

export const pageSize = 10;

export const viewIds = {
  oneDay: 'fullday',
  twoDays: 'fulldays-2',
  oneWorkWeek: 'workweek',
  twoWorkWeeks: 'workweek-2',
  oneWeek: 'week',
  twoWeeks: 'week-2',
  month: 'month',
};

export const viewHoursMedium = [''];
export const viewHoursSmall = [viewIds.twoWorkWeeks, viewIds.twoWeeks, viewIds.oneWeek];
export const viewDateOnly = [viewIds.month];
export const dayViews = [viewIds.oneDay, viewIds.twoDays];


export default {
  defaultView,
  widthBoundaries,
  indicatorInterval,
  indicatorOffset,
  boardIdTypes,
  pageSize,
  viewHoursMedium,
  viewHoursSmall,
  viewDateOnly,
};
